export default "__VITE_ASSET__$CAEevXK__"